<div class="slides-menu-container">
    <div
        class="slide active p-4 mb-2"
        *ngIf="hasIntro"
        (click)="selectSlide(null)"
        [ngClass]="{ active: !currentSlide }"
    >
        Instructions
    </div>
    <div
        *ngFor="let slide of slides"
        class="slide p-4 mb-2"
        (click)="selectSlide(slide)"
        [ngClass]="{ active: slide.active }"
        [innerHTML]="slide.name | bypassSecurity: 'html'"
    ></div>
</div>
